import React from 'react';
import { Button, Form, Input } from 'antd';

import styles from '../Form.module.css';

export default function FormAdmin() {

    return (
        <Form
            name='basic'
            size='large'
            labelCol={{
                span: 4,
            }}
            wrapperCol={{
                span: 18,
            }}
            autoComplete='off'
        >
            <Form.Item
                label='Логин'
                name='user'
                rules={[
                    {
                        required: true,
                        message: 'Необходимо указать логин',
                    },
                ]}
            >
                <Input />
            </Form.Item>
            <Form.Item
                wrapperCol={{
                    offset: 6,
                    span: 16,
                }}
            >
                <div className={styles.buttonContainer}>
                    <Button  className={styles.formButton} type='primary' htmlType='submit'>
                        Добавить администратора
                    </Button>
                </div>
            </Form.Item>
        </Form>
    );
}
